import { useContext } from 'react';
import { SelectedStationContext } from '../context/SelectedStationContextValue';

export const useSelectedStation = () => {
  const value = useContext(SelectedStationContext);

  if (!value) {
    throw new Error('useSelectedStation must be used inside SelectedStationProvider');
  }

  return value;
};
